export default function queries(store){
	return function(view = null){
		const query = store.getters['queries/get'](view);

		return {
			set: (params) => store.dispatch('queries/set', { view, params }),
			reset: () => store.dispatch('queries/reset', view),
			get limit(){
				return query.limit;
			},
			set limit(value){
				return store.commit('QUERIES/SET', {view, params: {limit: value}})
			},
			get search() {
				return query.search;
			},
			set search(value = '') {
				return store.dispatch('queries/search', { view, value });
			},
			get filters() {
				return query.filter;
			},
			get orders() {
				return query.order;
			},
			order: {
				add({ field, value = null}){
					return store.dispatch('queries/order/add', { view, field, value});
				},
				delete(field){
					return store.dispatch('queries/order/delete', { view, field });
				},
				reset() {
					return store.dispatch('queries/order/reset', view);
				},
			},
			filter: {
				add({type, field, value, lig = null, from = null, to = null}) {
					return store.dispatch('queries/filter/add', { view, type, field, value, lig, from, to });
				},
				delete({ type = null, field = null, value = null, lig = null, from = null, to = null}) {
					return store.dispatch('queries/filter/delete', { view, type, field, value, lig, from, to});
				},
				search({ type = null, field, value = null, lig = null, from = null, to = null }) {
					return store.getters['queries/filter/search']({ view, type, field, value, lig, from, to });
				},
				reset() {
					return store.dispatch('queries/filter/reset', view);
				},
			}
		}
	}
};
